export const config = {
  getStarted: 'Get started',
}
